export default [
  {
    duration: 0.545454,
    durationTicks: 384,
    midi: 40,
    name: 'E2',
    ticks: 0,
    time: 0,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.27272699999999994,
    durationTicks: 192,
    midi: 40,
    name: 'E2',
    ticks: 576,
    time: 0.818181,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454540000000001,
    durationTicks: 384,
    midi: 40,
    name: 'E2',
    ticks: 768,
    time: 1.090908,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.27272699999999994,
    durationTicks: 192,
    midi: 42,
    name: 'F#2',
    ticks: 1344,
    time: 1.909089,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999999,
    durationTicks: 384,
    midi: 43,
    name: 'G2',
    ticks: 1536,
    time: 2.181816,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.27272700000000016,
    durationTicks: 192,
    midi: 42,
    name: 'F#2',
    ticks: 2112,
    time: 2.999997,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999999,
    durationTicks: 384,
    midi: 43,
    name: 'G2',
    ticks: 2304,
    time: 3.272724,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454540000000003,
    durationTicks: 384,
    midi: 38,
    name: 'D2',
    ticks: 3072,
    time: 4.363632,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.2727269999999997,
    durationTicks: 192,
    midi: 38,
    name: 'D2',
    ticks: 3648,
    time: 5.181813,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454540000000003,
    durationTicks: 384,
    midi: 38,
    name: 'D2',
    ticks: 3840,
    time: 5.45454,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.2727270000000006,
    durationTicks: 192,
    midi: 40,
    name: 'E2',
    ticks: 4416,
    time: 6.272721,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 42,
    name: 'F#2',
    ticks: 4608,
    time: 6.545448,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454540000000003,
    durationTicks: 384,
    midi: 35,
    name: 'B1',
    ticks: 5376,
    time: 7.636356,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 40,
    name: 'E2',
    ticks: 6144,
    time: 8.727264,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.2727270000000015,
    durationTicks: 192,
    midi: 40,
    name: 'E2',
    ticks: 6720,
    time: 9.545444999999999,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 40,
    name: 'E2',
    ticks: 6912,
    time: 9.818172,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.2727269999999997,
    durationTicks: 192,
    midi: 47,
    name: 'B2',
    ticks: 7488,
    time: 10.636353,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454540000000012,
    durationTicks: 384,
    midi: 43,
    name: 'G2',
    ticks: 7680,
    time: 10.90908,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.2727269999999997,
    durationTicks: 192,
    midi: 42,
    name: 'F#2',
    ticks: 8256,
    time: 11.727261,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 43,
    name: 'G2',
    ticks: 8448,
    time: 11.999988,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 38,
    name: 'D2',
    ticks: 9216,
    time: 13.090896,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.2727269999999997,
    durationTicks: 192,
    midi: 38,
    name: 'D2',
    ticks: 9792,
    time: 13.909077,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 38,
    name: 'D2',
    ticks: 9984,
    time: 14.181804,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.2727269999999997,
    durationTicks: 192,
    midi: 40,
    name: 'E2',
    ticks: 10560,
    time: 14.999985,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 42,
    name: 'F#2',
    ticks: 10752,
    time: 15.272712,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.2727269999999997,
    durationTicks: 192,
    midi: 40,
    name: 'E2',
    ticks: 11328,
    time: 16.090893,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 42,
    name: 'F#2',
    ticks: 11520,
    time: 16.36362,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 45,
    name: 'A2',
    ticks: 11904,
    time: 16.909074,
    velocity: 0.3937007874015748,
  },
  {
    duration: 0.5454539999999994,
    durationTicks: 384,
    midi: 40,
    name: 'E2',
    ticks: 12288,
    time: 17.454528,
    velocity: 0.3937007874015748,
  },
]
